// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-ts": () => import("./../src/pages/index.ts" /* webpackChunkName: "component---src-pages-index-ts" */)
}

